import styled from 'styled-components';
import { motion } from 'framer-motion';
import { variant } from 'styled-system';
import { NavLink } from 'react-router-dom';
import Typography from '../../styles/Typography';
import { textStyles } from '../../../theme/config/typography';

export const StyledMenuDropdown = styled.div`
  position: relative;
  z-index: 3;
`;

export const StyledMenuDropdownAvatarBtn = styled.button`
  width: 34px;
  height: 34px;
  border-radius: var(--r-full);
  border: none;
  padding: 0;
  cursor: pointer;
  background: var(--brand-ink);
  color: var(--surface);
  font-size: var(--t-sm);
  font-weight: 600;
  font-family: inherit;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  transition: opacity var(--dur-fast) var(--ease-out);

  &:hover { opacity: 0.85; }
`;

export const StyledMenuDropdownButton = styled.button`
  background-color: transparent;
  border: 0;
  padding: 0;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--muted);
  transition: color var(--dur-fast) var(--ease-out);
  cursor: pointer;
  &:hover {
    color: var(--ink);
  }
  svg {
    height: 1em;
    width: 1em;
    font-size: 1.5rem;
    fill: currentColor;
  }
`;

export const StyledMenuDropdownContentWrapper = styled(motion.div).attrs({
  key: 'menu-dropdown',
  initial: { opacity: 0, y: '-16px' },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: '-16px' },
  transition: { duration: 0.2, type: 'tween' },
})`
  min-width: 12rem;
  position: absolute;
  top: calc(100% + 0.5rem);
  inset-inline-end: 0;
`;

export const StyledMenuDropdownContent = styled.div`
  width: 100%;
  background-color: var(--surface);
  border-radius: var(--r-lg);
  box-shadow: var(--sh-3);
  border: 1px solid var(--line);
  padding: 0.875rem 0;
`;

export const StyledMenuDropdownTitle = styled(Typography).attrs({
  forwardedAs: 'h3',
  variant: 'body',
})`
  text-transform: uppercase;
  color: var(--muted-2);
  margin-bottom: 0.5rem;
  padding: 0 1.125rem;
`;

export const StyledMenuDropdownList = styled.ul`
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const StyledMenuDropdownListItem = styled.li`
  width: 100%;
`;

export const StyledMenuDropdownLink = styled(NavLink).attrs({
  variant: 'body',
  activeClassName: 'is-active',
})`
  transition: background-color var(--dur-fast) var(--ease-out);
  color: var(--ink);
  background-color: transparent;
  padding: 0.5rem 1.125rem;
  text-decoration: none;
  display: block;
  ${variant({
    variants: {
      ...textStyles,
    },
  })};
  &.is-active {
    background-color: var(--paper);
  }
  &:hover {
    background-color: var(--paper);
  }
`;

export const StyledMenuDropdownLinkButton = styled.button.attrs({
  variant: 'body',
})`
  border: 0;
  outline: none;
  cursor: pointer;
  padding: 0.5rem 1.125rem;
  transition: background-color var(--dur-fast) var(--ease-out);
  color: var(--ink);
  background-color: transparent;
  display: block;
  width: 100%;
  text-align: start;
  ${variant({
    variants: {
      ...textStyles,
    },
  })};
  &:hover {
    background-color: var(--paper);
  }
`;
